// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"ActionButton_actionButton__3MJYX","edit":"ActionButton_edit__1KgsE","delete":"ActionButton_delete__1yAkz"};